import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { prop } from 'ramda';

import { useAppSelector } from '@core/js/store/hooks';

import { setShowAccountMenu } from '@interlayer/js/components/system/App/store/buzz/actions';

export const useSwitchAccountMenu = () => {
    const dispatch = useDispatch();
    const showAccountMenu = useAppSelector(prop('showAccountMenu'));

    return useCallback((isShow = !showAccountMenu) => {
        dispatch(setShowAccountMenu(isShow));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);
};
